// =================================================================
// RequireAdmin
//
// Guards admin pages. If the user isn't signed in, redirects to
// /admin/login. If they're signed in but have no admin access at
// all (no communities they admin, not super-admin), redirects to
// /admin/no-access.
//
// Some admin pages additionally check for super-admin specifically
// (community management, catalog) — they use RequireSuperAdmin.
// =================================================================

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/useAuth.jsx';
import { useAdminAccess } from '../lib/useAdminAccess.jsx';

export default function RequireAdmin({ children }) {
  const { user, loading: authLoading } = useAuth();
  const { hasAnyAccess, loading: accessLoading } = useAdminAccess();
  const location = useLocation();

  if (authLoading || accessLoading) {
    return (
      <div className="container" style={{ paddingTop: '4rem' }}>
        <p style={{
          fontFamily: 'var(--font-serif)',
          fontStyle: 'italic',
          color: 'var(--ink-faded)',
        }}>
          Checking your sign-in…
        </p>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ returnTo: location.pathname }}
      />
    );
  }

  if (!hasAnyAccess) {
    return <Navigate to="/admin/no-access" replace />;
  }

  return children;
}
